<template v-if="!loading">
  <v-container>
    <!-- Setor selecionado -->
    <v-col cols="12" class="mb-1">
      <h5>Reposicionamento de Máquinas</h5>
      <v-divider class="mb-2"></v-divider>
      <span v-if="filas.length > 0">
        <h4 v-if="setorSelecionado">{{ setorSelecionado.descricao_setor }}</h4>
        <h4 v-if="subSetorSelecionado">{{ subSetorSelecionado.descricao_sub_setor }}</h4>
      </span>
    </v-col>

    <v-card class="elevation-0">





      <v-card-text class="dialog-content">

        <!-- Diálogo de confirmação de cancelamento -->
        <v-dialog v-model="cancelarDialog" max-width="500">
          <v-card>
            <v-card-title class="text-danger">
              Confirmar Cancelamento</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              Tem certeza de que deseja cancelar? Todas as mudanças serão perdidas.
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="cancelarDialog = false">Não</v-btn>
              <v-btn color="red darken-1" text @click="voltarMenu">Sim, Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Diálogo de Confirmação -->
        <v-dialog v-model="confirmDialog" max-width="500">
          <v-card>
            <v-card-title class="headline">Confirmação</v-card-title>
            <v-card-text>
              Tem certeza de que deseja finalizar e reposicionar as máquinas?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="confirmDialog = false">Cancelar</v-btn>
              <v-btn color="green darken-1" text @click="finalizar">Confirmar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Diálogo de Carregamento -->
        <v-dialog v-model="loadingDialog" persistent max-width="300">
          <v-card>
            <v-card-text class="text-center">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
              <p> {{ mensagemDialog }}</p>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Diálogo de Sucesso -->
        <v-dialog v-model="successDialog" max-width="500">
          <v-card>
            <v-card-title class="headline">Sucesso</v-card-title>
            <v-card-text>
              As máquinas foram reposicionadas com sucesso!
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="recarregarPagina">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Diálogo de Erro -->
        <v-dialog v-if="errorDialog" v-model="errorDialog" max-width="500">
          <v-card>
            <v-card-title class="headline">Erro</v-card-title>
            <v-card-text>
              Ocorreu um erro ao reposicionar as máquinas. Tente novamente.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="errorDialog = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Diálogo de Exclusão de Máquina -->
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-card-title class="headline mb-2 mt-2">Você tem certeza que deseja excluir</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="headline mb-2 mt-2">
              A máquina Pos-{{ selectedMachine?.posicao }} | Maq-{{
                selectedMachine?.id }}?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog = false">Cancelar</v-btn>
              <v-btn color="red darken-1" text @click="confirmarExcluir">Excluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- dialoagConfirmarFilas -->
        <v-dialog v-model="dialoagConfirmarFilas" persistent max-width="500px">
          <v-card>
            <!-- Título del diálogo -->
            <v-card-title class="text-h6 font-weight-bold bg-primary white--text">
              Atenção! Adicionar as Filas
            </v-card-title>

            <!-- Divider para separar título del contenido -->
            <v-divider></v-divider>

            <!-- Contenido del diálogo -->
            <v-card-text class="py-4">
              <p class="mb-2 text-body-1 font-weight-regular">
                Será adicionar {{ numeroFilas }} filas. Deseja continuar?
              </p>
            </v-card-text>

            <!-- Divider para separar contenido de las acciones -->
            <v-divider></v-divider>

            <!-- Botones de acción -->
            <v-card-actions class="justify-end">
              <v-btn text @click="closeModalFilas" color="secondary">Cancelar</v-btn>
              <v-btn @click="adicionarFila" color="primary" :loading="loading" class="ml-2" elevation="1">
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Seleção de Setor e Sub-Setor -->
        <v-col v-if="filas.length === 0" cols="12">
          <v-btn color="purple" text block justify="center" @click="sheetSetor = true">
            {{ setorSelecionado ? setorSelecionado.descricao_setor : "Selecionar Setor" }}
          </v-btn>


          <v-bottom-sheet v-model="sheetSetor" :fullscreen="isMobile()" max-width="600px">
            <v-sheet class="pa-4">
              <v-card>
                <!-- Campo de pesquisa fixo para Setor -->
                <v-text-field v-model="searchSetor" label="Pesquisar Setor" clearable class="mb-2"
                  prepend-icon="mdi-magnify"
                  style="position: sticky; top: 0; background-color: white; z-index: 10;"></v-text-field>

                <v-list>
                  <v-list-subheader>Selecione o Setor</v-list-subheader>
                  <v-list-item v-for="setor in getSetoresFiltrados()" :key="setor.id" @click="selectSetor(setor)">
                    <v-list-item-title>{{ setor.descricao_setor }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-sheet>
          </v-bottom-sheet>
        </v-col>


        <v-col v-if="filas.length === 0" cols="12" v-show="setorSelecionado">
          <v-btn color="purple" text block justify="center" @click="sheetSubSetor = true">

            {{ subSetorSelecionado ? subSetorSelecionado.descricao_sub_setor : "Selecionar Sub-Setor" }}
          </v-btn>

          <v-bottom-sheet v-model="sheetSubSetor" :fullscreen="isMobile()" max-width="600px">
            <v-sheet class="pa-4">
              <v-card>
                <!-- Campo de pesquisa fixo -->
                <v-text-field v-model="searchSubSetor" label="Pesquisar Sub-Setor" clearable class="mb-2"
                  prepend-icon="mdi-magnify"
                  style="position: sticky; top: 0; background-color: white; z-index: 10;"></v-text-field>

                <v-list>
                  <v-list-subheader>Selecione o Sub-Setor</v-list-subheader>
                  <v-list-item v-for="subSetor in getSubSetoresFiltrados()" :key="subSetor.id"
                    @click="selectSubSetor(subSetor)">
                    <v-list-item-title>{{ subSetor.descricao_sub_setor }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-sheet>
          </v-bottom-sheet>
        </v-col>


        <!-- Gerenciamento de Filas e Máquinas -->
        <v-container v-if="setorSelecionado && subSetorSelecionado">
          <v-row v-if="filas.length === 0">
            <v-col cols="12">
              <h3>Gerenciamento de Filas</h3>
              <v-text-field label="Número de Filas" v-model="numeroFilas" type="number" min="1" required></v-text-field>
              <v-btn color="green" @click="showModalFilas">Adicionar</v-btn>
            </v-col>
          </v-row>

          <v-row class="mt-5" v-if="filas.length > 0">
            <v-col cols="12" v-for="(fila, index) in filas" :key="fila.id" class="mb-4">
              <v-card>
                <v-card-title class="fila-header text-body-2">
                  <span>Fila {{ String(fila.id).padStart(2, '0') }}</span>
                </v-card-title>

                <v-card-subtitle class="px-4">
                  <v-row class="mt-2 mb-3 ml-2">
                    <v-text-field v-model="maquinaSelecionadaId" label="Máquina" variant="underlined" hide-details
                      @keyup.enter="adicionarMaquina(fila)"
                      @keydown.tab.prevent="adicionarMaquina(fila)"></v-text-field>
                    <v-btn color="green" small @click="adicionarMaquina(fila)">
                      Adcionar
                    </v-btn>
                  </v-row>
                </v-card-subtitle>

                <v-divider></v-divider>

                <v-card-text class="ml-3 mr-3">
                  <div v-if="fila.maquinas.length > 0" class="maquina-table">
                    <v-row>
                      <v-col v-for="(maquina, idx) in fila.maquinas" :key="maquina.id" cols="12" sm="6" md="4" lg="3">
                        <v-card class="mt-1 maquina-card" :style="{ backgroundColor: maquina.corFundo }"
                          @click="openDeleteDialog(maquina, fila)">
                          <v-card-text class="ml-5">
                            <v-row>
                              <v-col cols="8">Posição</v-col>
                              <v-col cols="4">{{ String(maquina.posicao).padStart(2, '0') }}</v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row>
                              <v-col cols="7">Maq</v-col>
                              <v-col cols="5">{{ String(maquina.id).padStart(3, '0') }}</v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else class="d-flex align-center justify-center" style="height: 100px;">
                    <p class="text-center">Sem máquinas na fila {{ fila.id }}</p>
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn color="light-blue" small @click="removerFila(index)" class="full-width-btn">
                    <v-icon left>mdi-delete</v-icon> Remover Fila
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <!-- Resumo de Etiquetas a serem impressas -->
          <v-row class="mt-5">
            <v-col cols="12">
              <!-- Mostrar máquinas que têm etiqueta marcada como SIM -->
              <v-card v-if="getMaquinasComEtiqueta().length > 0">
                <v-card-title class="fila-header text-body-2">Etiquetas</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <ul>
                    <li class='ml-5' v-for="maquina in getMaquinasComEtiqueta()" :key="maquina.id">
                      Maq-{{ String(maquina.id).padStart(3, '0') }} (Posição {{ String(maquina.posicao).padStart(2, '0')
                      }}) - {{ maquina.descricao }}
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <!-- Mostrar máquinas que pertencem ao setor e sub-setor mas não foram adicionadas a filas -->
              <v-card v-if="getMaquinasNaoAdicionadas().length > 0 && filas.length > 0" class="mt-4">
                <v-card-title class="fila-header text-body-2">
                  (Será adicionada ao Setor Conferência)
                </v-card-title>

                <v-card-text>
                  <ul>
                    <li class='ml-5' v-for="maquina in getMaquinasNaoAdicionadas()" :key="maquina.id">
                      Maq-{{ String(maquina.id).padStart(3, '0') }} - {{ maquina.descricao }} (Setor Conferência)
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-btn v-if='filas.length > 0' class="mt-3" color="green" @click="confirmFinalizar">
            Finalizar
          </v-btn>
        </v-container>
      </v-card-text>
    </v-card>


    <!-- Área dos Botões -->
    <div class="buttons-container">
      <v-row justify="center">
        <!-- Botões de Ação -->
        <!-- <v-btn color="green" @click="confirmFinalizar">
          Finalizar
        </v-btn> -->
        <v-btn color="secondary" class="mx-2" @click="opcaoconfirmCancelar">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      </v-row>
    </div>


  </v-container>
</template>

<script>
import { maquinaMapaService } from "@/services/maquinaMapaService"; // Importando o serviço criado
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      mensagemDialog: "Carregando dados...",
      dialoagConfirmarFilas: false,
      searchSubSetor: "",
      searchSetor: "", // Campo de pesquisa para setor

      confirmDialog: false,
      loadingDialog: false,
      loading: true, // Variável de carregamento inicial

      successDialog: false,
      errorDialog: false,
      cancelarDialog: false,
      setores: [],
      subSetores: [],
      maquinas: [],
      filas: [],
      setorSelecionado: null,
      subSetorSelecionado: null,
      sheetSetor: false,
      sheetSubSetor: false,
      maquinaSelecionadaId: "",
      dialog: false,
      selectedMachine: null,
      selectedFila: null,
      numeroFilas: "",
      idFilaProxima: 1,
    };
  },
  methods: {
    voltarMenu() {
      this.$router.push({ name: 'MenuDefault' }).catch(() => { });
    },
    showModalFilas() {
      this.dialoagConfirmarFilas = true;
    },
    closeModalFilas() {
      this.numeroFilas = "";
      this.dialoagConfirmarFilas = false;
    },
    // Abre o diálogo de confirmação para finalizar
    opcaoconfirmCancelar() {
      // Abre o diálogo de confirmação
      // this.$router.push({ name: 'MenuDefault' }).catch(() => { });
      this.cancelarDialog = true;
    },

    confirmFinalizar() {
      // Abre o diálogo de confirmação
      this.confirmDialog = true;
    },
    getSetoresFiltrados() {
      return this.setores
        .filter((setor) =>
          setor.descricao_setor.toLowerCase().includes(this.searchSetor.toLowerCase())
        )
        .sort((a, b) => a.descricao_setor.localeCompare(b.descricao_setor));
    },

    getSubSetoresFiltrados() {
      if (this.setorSelecionado) {
        return this.subSetores
          .filter(
            (subSetor) =>
              subSetor.id_setor === this.setorSelecionado.id &&
              subSetor.descricao_sub_setor.toLowerCase().includes(this.searchSubSetor.toLowerCase())
          )
          .sort((a, b) => a.descricao_sub_setor.localeCompare(b.descricao_sub_setor));
      }
      return [];
    },



// Carrega os dados iniciais: setores, sub-setores e máquinas
async carregarDados() {
  const toast = useToast();
  this.loadingDialog = true;

  try {
    // Carrega as máquinas primeiro
    const maquinas = await maquinaMapaService.fetchMaquinas();
    this.maquinas = maquinas.map(maquina => ({
      ...maquina,
      id_setor: maquina.id_setor,         // Adiciona id_setor
      id_sub_setor: maquina.id_sub_setor, // Adiciona id_sub_setor
    }));

    // Carrega os setores
    this.setores = await maquinaMapaService.fetchSetores();

    // Carrega os sub-setores
    this.subSetores = await maquinaMapaService.fetchSubSetores();

    toast.success("Dados carregados com sucesso!");
  } catch (error) {
    console.error("Erro ao carregar dados:", error);
    this.errorDialog = true;
    toast.error("Erro ao carregar dados. Tente novamente.");
  }

  this.loadingDialog = false;
}
,





    // Confirma a finalização do reposicionamento
    confirmarFinalizacao() {
      this.confirmDialog = true;
    },

    // Finaliza o reposicionamento das máquinas
    async finalizar() {
      this.confirmDialog = false;
      this.loadingDialog = true;
      const toast = useToast();
      try {
        const response = await maquinaMapaService.reposicionarMaquinas({
          setor_atual_id: this.setorSelecionado.id,
          sub_setor_atual: this.subSetorSelecionado.id,

          filas: this.filas,

          maquinas_movidas: this.getMaquinasNaoAdicionadas().map(maquina => maquina.id),
        });
        if (response.status === 'success') {
          this.successDialog = true;
          toast.success("Máquinas reposicionadas com sucesso!");
        } else {
          throw new Error(response.error_message || "Erro desconhecido");
        }
      } catch (error) {
        console.error("Erro ao finalizar:", error);
        this.errorDialog = true;
        toast.error("Erro ao finalizar o reposicionamento. Tente novamente.");
      }
      this.loadingDialog = false;
    },

    // Cancela a operação e recarrega a página
    cancelarAcao() {
      this.cancelarDialog = true;

    },
    // Abre o diálogo de confirmação de cancelamento
    confirmarCancelar() {
      this.cancelarDialog = true;
    },

    // Seleciona um setor e filtra os sub-setores correspondentes
    selectSetor(setor) {
      this.setorSelecionado = setor;
      this.sheetSetor = false;
      this.subSetorSelecionado = null; // Reseta o sub-setor ao mudar o setor
    },

    // Seleciona um sub-setor
    selectSubSetor(subSetor) {
      this.subSetorSelecionado = subSetor;
      this.sheetSubSetor = false;
    },

    // Filtra os sub-setores com base no setor selecionado
    getSubSetoresFiltrados() {
      if (this.setorSelecionado) {
        return this.subSetores.filter(
          (subSetor) => subSetor.id_setor === this.setorSelecionado.id
        );
      }
      return [];
    },

    // Adiciona uma ou mais filas com base no número especificado

    adicionarFila() {
      this.dialoagConfirmarFilas = false;

      const numero = parseInt(this.numeroFilas, 10);
      if (numero > 0) {
        for (let i = 0; i < numero; i++) {
          this.filas.push({
            id: this.idFilaProxima,
            maquinas: [],
          });
          this.idFilaProxima++;
        }
        this.numeroFilas = "";
      } else {
        alert("O número de filas deve ser maior que 0!");
      }
    },

    // Remove uma fila específica
    removerFila(index) {
      this.filas.splice(index, 1);
    },

    // Adiciona uma máquina a uma fila específica com validações
    adicionarMaquina(fila) {
      // Processa o ID da máquina
      let idMaquina = this.maquinaSelecionadaId.trim();

      if (idMaquina.startsWith("MAQ") || idMaquina.startsWith("MAR")) {
        idMaquina = parseInt(idMaquina.replace(/\D/g, ''), 10);
      }

      const maquinaSelecionada = this.maquinas.find(m => m.id == idMaquina);

      if (!maquinaSelecionada) {
        alert("Máquina não encontrada ou ID inválido.");
        this.maquinaSelecionadaId = "";
        return;
      }

      // Verifica se a máquina já está em alguma fila
      const maquinaEmUso = this.filas.find(f => f.maquinas.find(m => m.id == maquinaSelecionada.id));
      if (maquinaEmUso) {
        const posicao = maquinaEmUso.maquinas.find(m => m.id == maquinaSelecionada.id).posicao;
        alert(`A máquina já está sendo utilizada na Fila ${maquinaEmUso.id}, Posição ${posicao}.`);
        this.maquinaSelecionadaId = "";
        return;
      }

      // Verifica se a máquina pertence ao setor e sub-setor selecionados
      const pertenceAoSetor = this.setorSelecionado.id === maquinaSelecionada.id_setor;
      const pertenceAoSubSetor = this.subSetorSelecionado.id === maquinaSelecionada.id_sub_setor;

      let corFundo = "#e0f7fa"; // Azul claro
      let gerar_etiqueta = "NAO";

      if (!pertenceAoSetor || !pertenceAoSubSetor) {
        corFundo = "#ffcccc"; // Vermelho claro
        gerar_etiqueta = "SIM";
      }

      const posicao = fila.maquinas.length + 1;

      fila.maquinas.push({
        id: maquinaSelecionada.id,
        descricao: maquinaSelecionada.descricao_maquina,
        numero_serie: maquinaSelecionada.numero_serie,
        posicao: posicao,
        id_setor: maquinaSelecionada.id_setor,
        setor: this.setorSelecionado.descricao_setor,
        id_sub_setor: maquinaSelecionada.id_sub_setor,
        subSetor: this.subSetorSelecionado.descricao_sub_setor,
        modelo: maquinaSelecionada.modelo,
        marca: maquinaSelecionada.marca,
        tipo_maquinas: maquinaSelecionada.tipo_maquinas,
        corFundo: corFundo,
        gerar_etiqueta: gerar_etiqueta,
      });

      this.maquinaSelecionadaId = "";
    },

    // Abre o diálogo de confirmação para excluir uma máquina
    openDeleteDialog(maquina, fila) {
      this.selectedMachine = maquina;
      this.selectedFila = fila;
      this.dialog = true;
    },

    // Confirma a exclusão da máquina e reorganiza as posições
    confirmarExcluir() {
      const index = this.selectedFila.maquinas.findIndex(m => m.id === this.selectedMachine.id);
      if (index !== -1) {
        this.selectedFila.maquinas.splice(index, 1);
        this.reorganizarPosicoes(this.selectedFila.maquinas);
      }
      this.dialog = false;
    },

    // Reorganiza as posições das máquinas após uma remoção
    reorganizarPosicoes(maquinas) {
      maquinas.forEach((maquina, index) => {
        maquina.posicao = index + 1;
      });
    },

    // Reposiciona as máquinas enviando os dados para a API
    // Reposiciona as máquinas enviando os dados para a API



    // Obtém máquinas que requerem etiquetas
    getMaquinasComEtiqueta() {
      let maquinasComEtiqueta = [];
      this.filas.forEach(fila => {
        fila.maquinas.forEach(maquina => {
          if (maquina.gerar_etiqueta === "SIM") {
            maquinasComEtiqueta.push(maquina);
          }
        });
      });
      return maquinasComEtiqueta;
    },

    // Obtém máquinas que não foram adicionadas a nenhuma fila
    getMaquinasNaoAdicionadas() {
      const maquinasAdicionadasIds = this.filas.flatMap(fila => fila.maquinas.map(m => m.id));
      return this.maquinas.filter(maquina =>
        maquina.id_setor === this.setorSelecionado.id &&
        maquina.id_sub_setor === this.subSetorSelecionado.id &&
        !maquinasAdicionadasIds.includes(maquina.id)
      );
    },

    // Recarrega a página após sucesso
    recarregarPagina() {
      location.reload();
    },

    // Verifica se o dispositivo é móvel para ajustar o layout
    isMobile() {
      return window.innerWidth <= 600;
    },
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        await this.carregarDados();
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        this.errorDialog = true;
      } finally {
        this.loading = false; // Define como falso após o carregamento
      }
    });
  }

};
</script>

<style scoped>
.fila-header {
  background-color: #2196f3;
  color: white;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  padding: 5px;
  border-top-left-radius: 8px;
  /* Apenas canto inferior esquerdo */
  border-top-right-radius: 8px;
  /* Apenas canto inferior direito */
}

.maquina-table {
  display: table;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.maquina-card {
  background-color: #e0f7fa;
  cursor: pointer;
}

.machine-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.full-width-btn {
  width: 100%;
  justify-content: center;
}

.fila-header {
  font-weight: bold;
}

.v-card-text ul {
  list-style-type: none;
  padding: 0;
}

.v-card-text li {
  padding: 5px 0;
}

.v-card-text {
  padding: 0;
  margin-left: -1em;
}

.dialog-content {
  max-height: 65vh;
  /* Altura máxima padrão */
  overflow-y: auto;
  overflow-x: auto;
  transition: padding-bottom 0.3s ease;
  /* Adiciona uma transição suave */
}

/* Ajuste para telas grandes */
@media (min-width: 1024px) {
  .dialog-content {
    max-height: 75vh;
    /* Altura máxima maior em telas grandes */
  }
}

/* Estilo para o container dos botões */
.buttons-container {
  padding: 16px;
  margin-top: 16px;
  background-color: white;
}

.mb-1 {
  margin-bottom: 4px;
  /* Ajuste de espaçamento para reduzir o espaço entre elementos */
}

.sub-setor-text span {
  font-size: 0.875rem;
  /* Tamanho de fonte menor para o sub-setor */
  color: #666;
  /* Cor opcional para diferenciar o sub-setor */
}
</style>
